import { useEffect } from "react";

import { useDocumentElement } from "./hooks/useDocumentElement";

interface NavatticEmbedProps {
  id: string;
  buttonText: string;
}

interface NavatticWindow extends Window {
  NavatticEmbed?: {
    loadEmbeds: () => void;
  };
}

export const NavatticEmbed = ({ id, buttonText }: NavatticEmbedProps) => {
  const [scriptsLoaded] = useDocumentElement({
    scriptSrc: "https://js.navattic.com/embeds.js",
  });

  useEffect(() => {
    if (scriptsLoaded) {
      const navatticWindow = window as NavatticWindow;

      if (navatticWindow.NavatticEmbed) {
        navatticWindow.NavatticEmbed.loadEmbeds();
      } else {
        document.querySelectorAll("iframe[data-navattic-src]:not([src])").forEach((e) => {
          const iframe = e as HTMLIFrameElement;
          if (iframe.dataset.navatticSrc) {
            iframe.src = iframe.dataset.navatticSrc;
          }
        });
      }
    }
  }, [scriptsLoaded]);

  return (
    <iframe
      // eslint-disable-next-line @eslint-react/dom/no-unsafe-iframe-sandbox
      sandbox="allow-scripts allow-same-origin"
      data-navattic-src={`https://capture.navattic.com/${id}`}
      data-navattic-placeholder-src={`https://app.navattic.com/api/poster/${id}`}
      data-navattic-button-text={buttonText}
      data-navattic-demo-id={id}
      data-cy="navattic-embed-iframe"
      style={{
        position: "absolute",
        border: "none",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: "100%",
        height: "100%",
        margin: 0,
        padding: 0,
        zIndex: 999999,
      }}
    />
  );
};
